import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { useInstance } from 'intact-vue-next';
import { useState, watchState } from '../../hooks/useState';
import { isEqualArray } from '../utils';
import { isFunction } from 'intact-shared';
export function useTransfer() {
  var instance = useInstance();
  var rightData = useState([], isEqualArray);
  watchState(rightData, function (v) {
    var _instance$get = instance.get(),
      keyName = _instance$get.keyName;
    instance.set('value', _mapInstanceProperty(v).call(v, function (item) {
      return item[keyName];
    }));
  });
  function enableAdd() {
    var _instance$get2 = instance.get(),
      enableAdd = _instance$get2.enableAdd,
      leftCheckedKeys = _instance$get2.leftCheckedKeys;
    if (isFunction(enableAdd)) {
      return enableAdd();
    }
    return leftCheckedKeys.length;
  }
  function enableRemove() {
    var _instance$get3 = instance.get(),
      enableRemove = _instance$get3.enableRemove,
      rightCheckedKeys = _instance$get3.rightCheckedKeys;
    if (isFunction(enableRemove)) {
      return enableRemove();
    }
    return rightCheckedKeys.length;
  }
  function add() {
    var _context;
    var _instance$get4 = instance.get(),
      data = _instance$get4.data,
      leftCheckedKeys = _instance$get4.leftCheckedKeys,
      keyName = _instance$get4.keyName;
    var _rightData = _concatInstanceProperty(_context = rightData.value).call(_context, _filterInstanceProperty(data).call(data, function (item) {
      return ~leftCheckedKeys.indexOf(item[keyName]);
    }));
    rightData.set(_rightData);
    instance.set('leftCheckedKeys', []);
    instance.trigger('add');
  }
  function remove() {
    var _context2;
    var _instance$get5 = instance.get(),
      rightCheckedKeys = _instance$get5.rightCheckedKeys,
      keyName = _instance$get5.keyName;
    var _rightData = _filterInstanceProperty(_context2 = rightData.value).call(_context2, function (item) {
      return !~rightCheckedKeys.indexOf(item[keyName]);
    });
    rightData.set(_rightData);
    instance.set('rightCheckedKeys', []);
    instance.trigger('remove');
  }
  return {
    rightData: rightData,
    enableAdd: enableAdd,
    enableRemove: enableRemove,
    add: add,
    remove: remove
  };
}